import(/* webpackMode: "eager" */ "/srv/apps/internationaljobs/releases/bde75d4-202611040438/src/app/global-error.tsx");
